import React from 'react';
import styles from './header.module.css';
import WhichBinLogo from '../../assets/whicbin.svg';
import { Autocomplete } from '../Autocomplete';
import { useHistory } from 'react-router-dom';
export var Header = function () {
    var history = useHistory();
    return (React.createElement("div", { className: styles.header },
        React.createElement("div", { className: styles.logo, onClick: function () { return history.push('/'); } },
            React.createElement(WhichBinLogo, null)),
        React.createElement("div", { className: styles.search },
            React.createElement(Autocomplete, { placeholder: 'Search', openOnFocus: true, debug: true }))));
};
